import { useState } from "react";
import { SlidersHorizontal } from "lucide-react";
import { DrawingControls } from "./DrawingControls";
import { SelectionStyle } from "./SelectionStyle";
import type { WorkspaceModel } from "./useWorkspace";

/** Everyday defaults stay close to the tool; detailed properties are opt-in. */
export function DrawingToolbar({ model }: { model: WorkspaceModel }) {
  const [open, setOpen] = useState(false);
  const label =
    (
      {
        draw: "Pen",
        line: "Line",
        arrow: "Arrow",
        geo: "Rectangle",
        cloud: "Cloud",
        highlight: "Highlighter",
        polygon: "Polygon",
        dimension: "Dimension",
        area: "Area",
        angle: "Angle",
      } as Record<string, string>
    )[model.tool] || "Drawing";
  return (
    <>
      <div
        className="drawing-default-toolbar floating-surface"
        role="toolbar"
        aria-label={`${label} defaults`}
      >
        <strong>{label}</strong>
        <DrawingControls model={model} compact />
        <button
          aria-label="Drawing properties"
          title="Properties"
          aria-expanded={open}
          onClick={() => setOpen(!open)}
        >
          <SlidersHorizontal size={17} />
        </button>
      </div>
      {open && <SelectionStyle model={model} onClose={() => setOpen(false)} />}
    </>
  );
}
